import request from '@/utils/request.js'

export function accountbindinguid(data) {
  return request.get('/api/H5/LoginJwt/accountbindinguid', {
    params: data
  })
}

export function regbindinguid(data) {
  return request.get('/api/H5/LoginJwt/regbindinguid', {
    params: data
  })
}

export function reguser(data) {
  return request.get('/api/H5/LoginJwt/reguser', {
    params: data
  })
}

export function loginbypwd(data) {
  return request.get('/api/H5/LoginJwt/loginbypwd', {
    params: data
  })
}

export function loginbyphone(data) {
  return request.get('/api/H5/LoginJwt/loginbyphone', {
    params: data
  })
}

export function loginbyuid(data) {
  return request.get('/api/H5/LoginJwt/loginbyuid', {
    params: data
  })
}

export function rechargeloginpwd(data) {
  return request.get('/api/H5/LoginJwt/rechargeloginpwd', {
    params: data
  })
}
